import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';

export default WithApp(function ModalCuotaProduct(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [products, setProducts] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listProducts() {
    let response = await wsFindBy('logi/product', { base_business_partner_id: 8, deleted_at: 'null', state: 'A' });
    if (response.success) setProducts(response.data);
  }

  async function listDivisions() {
    let response = await wsGetAll('sale/arcor_divisions');
    if (response.success) setDivisions(response.data);
  }

  useEffect(() => {
    if (products.length > 0 && cuota.logi_product_id) {
      handleChange('logi_product_id', String(cuota.logi_product_id));
    }
  }, [products]);

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        sale_arcor_division_id: cuota.sale_arcor_division_id,
      });
      listProducts();
      listDivisions();
      setDataExcel(undefined);
      setDataImport(null);
    }
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setDataChanging([]);
      setDataExcel({
        success: dataImport.success,
        products: dataImport.data.map((item) => {
          return {
            ItemCode: item.PRODUCTO,
            division_code: item.DIVISION,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      setDataExcel(undefined);
    }
  }, [dataImport]);

  return (
    <>
      <Modal
        title={`Nueva cuota de producto arcor`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataExcel?.success
            ? 'sale/arcor_quota_products/multiple'
            : 'sale/arcor_quota_products'
        }
        dataForce={
          dataExcel?.success
            ? { products: dataExcel?.products }
            : {
                logi_product_id: dataChanging.logi_product_id,
                sale_arcor_division_id: dataChanging.sale_arcor_division_id,
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={divisions}
            getOptionLabel={(item) => item.description}
            renderInput={(params) => (
              <TextField {...params} label="División" margin="normal" fullWidth />
            )}
            onChange={(e, item) => { handleChange('sale_arcor_division_id', item?.id);setDataImport(null); }}
            value={divisions.find((d) => String(d.id) === String(dataChanging.sale_arcor_division_id)) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['PRODUCTO','DIVISION']}
            sortDuplicate={['PRODUCTO','DIVISION']}
            downTemplate={{
              fileNameDown: `${periodo}_Plantilla de productos arcor`,
              fields: ['PRODUCTO', 'DIVISION'],
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {!dataImport?.success ? (
          <>
            <Autocomplete
              disableClearable
              options={products}
              getOptionLabel={(item) => `${item.ItemCode} - ${item.ItemName}`}
              renderInput={(params) => (
                <TextField {...params} label="Producto" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('logi_product_id', item?.id); }}
              value={products.find((product) => String(product.id) === String(dataChanging.logi_product_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
